import { BLOCK_TYPES, FIELD_TYPES } from './constants'

export default function createBlockModel(data, editor) {
  switch (data.type) {
    case BLOCK_TYPES.SECTION: {
      const SectionModel = require('../Section/model').default
      return new SectionModel(data, editor)
    }
    case BLOCK_TYPES.IMAGE: {
      const ImageModel = require('../blocks/Image/model').default
      return new ImageModel(data, editor)
    }
    case BLOCK_TYPES.VIDEO: {
      const VideoModel = require('../blocks/Video/model').default
      return new VideoModel(data, editor)
    }
    case BLOCK_TYPES.BUTTON: {
      const ButtonModel = require('../blocks/Button/model').default
      return new ButtonModel(data, editor)
    }
    case BLOCK_TYPES.SIMPLE_BUTTON: {
      const SimpleButtonModel = require('../blocks/SimpleButton/model').default
      return new SimpleButtonModel(data, editor)
    }
    case BLOCK_TYPES.SUBMIT_BUTTON: {
      const SubmitButtonModel = require('../blocks/SubmitButton/model').default
      return new SubmitButtonModel(data, editor)
    }
    case BLOCK_TYPES.CONFIRM_BUTTON: {
      const ConfirmButtonModel = require('../blocks/ConfirmButton/model')
        .default
      return new ConfirmButtonModel(data, editor)
    }
    case BLOCK_TYPES.SHARE:
    case BLOCK_TYPES.FOLLOW: {
      const SocialModel = require('../blocks/Social/model').default
      return new SocialModel(data, editor)
    }
    case BLOCK_TYPES.SHARE_V2:
    case BLOCK_TYPES.FOLLOW_V2: {
      const SocialModelV2 = require('../blocks/SocialV2/model').default
      return new SocialModelV2(data, editor)
    }
    case BLOCK_TYPES.SPACING: {
      const SpacingModel = require('../blocks/Spacing/model').default
      return new SpacingModel(data, editor)
    }
    case BLOCK_TYPES.DIVIDER: {
      const DividerModel = require('../blocks/Divider/model').default
      return new DividerModel(data, editor)
    }
    case BLOCK_TYPES.TEXT: {
      const TextModel = require('../blocks/Text/model').default
      return new TextModel(data, editor)
    }
    case BLOCK_TYPES.HTML: {
      const HtmlModel = require('../blocks/Html/model').default
      return new HtmlModel(data, editor)
    }
    case BLOCK_TYPES.FORM: {
      const FormModel = require('../blocks/Form/model').default
      return new FormModel(data, editor)
    }
    case BLOCK_TYPES.TIMER: {
      const TimerModel = require('../blocks/Timer/model').default
      return new TimerModel(data, editor)
    }
    case BLOCK_TYPES.BANNER: {
      const BannerModel = require('../blocks/Banner/model').default
      return new BannerModel(data, editor)
    }
    case BLOCK_TYPES.PRODUCT: {
      const ProductModel = require('../blocks/Product/model').default
      return new ProductModel(data, editor)
    }
    case BLOCK_TYPES.FIELD: {
      switch (data.fieldType) {
        case FIELD_TYPES.LONG_TEXT: {
          const LongTextModel = require('../fields/LongText/model').default
          return new LongTextModel(data, editor)
        }
        case FIELD_TYPES.SCALE: {
          const ScaleModel = require('../fields/Scale/model').default
          return new ScaleModel(data, editor)
        }
        case FIELD_TYPES.SELECT_MANY: {
          const SelectManyModel = require('../fields/SelectMany/model').default
          return new SelectManyModel(data, editor)
        }
        case FIELD_TYPES.SELECT_ONE: {
          const SelectOneModel = require('../fields/SelectOne/model').default
          return new SelectOneModel(data, editor)
        }
        case FIELD_TYPES.SHORT_TEXT: {
          const ShortTextModel = require('../fields/ShortText/model').default
          return new ShortTextModel(data, editor)
        }
      }
    }
    default: {
      const BlockModel = require('./model').BlockModel
      return new BlockModel(data, editor)
    }
  }
}
